<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
export default {
  data () {
    return {
      activeMenu: false,
      activeImage: '',
      activeDropdown: false
    }
  },
  computed: {
    props () {
      return this.$store.state.app.nav
    },
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    toggleMenu () {
      this.activeMenu = !this.activeMenu
      this.activeDropdown = false
      this.activeMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    onHover (i) {
      this.activeImage = i
    },
    onLeave () {
      this.activeImage = ''
    },
    changePage (path) {
      this.activeDropdown = false
      this.$router.push(path)
      this.activeMenu = false
      this.activeMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    goContact () {
      this.activeDropdown = false
      this.$router.push('/contact-us')
      this.activeMenu = false
      this.activeMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
      setTimeout(() => {
        this.$scrollTo('#form-contact', { offset: -75 })
      }, 500)
    },
    goHome () {
      this.activeDropdown = false
      this.$router.push('/')
      this.activeMenu = false
      this.activeMenu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/navigation-desktop/navigation-desktop.vue